import { render, staticRenderFns } from "./ChapterSessionProgressionBlock.vue?vue&type=template&id=277d4f63&scoped=true&"
import script from "./ChapterSessionProgressionBlock.vue?vue&type=script&lang=js&"
export * from "./ChapterSessionProgressionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d4f63",
  null
  
)

export default component.exports